import React from 'react';
import { KafkaTopicByFunction } from '@hud/portal-dtos/webapp-function.dto';
import { HudIcon } from '../../Icons/HudIcons';
import { NodeTitleWithIconContainer } from './NodeTitleWithIconContainer';

export function TopicNodeBody({
  isMultiGroupTopic,
  topic,
}: {
  isMultiGroupTopic: boolean;
  topic: KafkaTopicByFunction;
}) {
  const multiGroupTopicLabel =
    isMultiGroupTopic ?? `(group ${topic.kafka_topic_group_id})`;
  const pathLabel = [
    topic.kafka_topic_name,
    multiGroupTopicLabel,
    topic.service.name,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <NodeTitleWithIconContainer
      title={topic.kafka_topic_name}
      icon={<HudIcon icon="entities.kafkaTopic" />}
      path={pathLabel}
    />
  );
}
